// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentV2RulesMetaRuleResultModel {
    static getAttributeTypeMap() {
        return EnrollmentV2RulesMetaRuleResultModel.attributeTypeMap;
    }
}
EnrollmentV2RulesMetaRuleResultModel.discriminator = undefined;
EnrollmentV2RulesMetaRuleResultModel.additionalProperties = false;
EnrollmentV2RulesMetaRuleResultModel.attributeTypeMap = [
    {
        "name": "bypassRuleTypeCode",
        "baseName": "bypassRuleTypeCode",
        "type": "string"
    },
    {
        "name": "bypassRuleCode",
        "baseName": "bypassRuleCode",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentV2RulesMetaRuleResultModel.js.map